import DonationAPI from './api'
import { objectToCamelCase, objectToSnakeCase } from '../utils'
import options from './options'

export default class Donation {
  static api = DonationAPI.create(Donation)
  static options = options
  static readOnlyFields = ['id', 'currency', 'status', 'datetimeCreated']
  constructor({
    id = '',
    amount = '',
    currency = '',
    status = '',
    datetimeCreated = '',
    organization = null,
    donor = '',
    frequency = null,
    frequencyDisplay = null,
    paymentSourceDisplay = null,
    paymentLast4 = null,
    paymentType = null,
    subscriptionId = null,
    isSubscriptionActive = false,
    mostRecentRecurringDate = '',
  } = {}) {
    Object.assign(this, {
      id,
      amount,
      currency,
      status,
      datetimeCreated,
      organization,
      donor,
      frequency,
      frequencyDisplay,
      paymentSourceDisplay,
      paymentLast4,
      paymentType,
      subscriptionId,
      isSubscriptionActive,
      mostRecentRecurringDate,
    })
  }

  static create(opts) {
    return new Donation(opts)
  }

  static fromAPI(json = {}) {
    return new Donation(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(donation, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = donation[field]
      })
    } else {
      data = donation
    }

    //
    excludeFields = [...Donation.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
}
